var render, staticRenderFns
import script from "./RichTextarea.vue?vue&type=script&lang=js"
export * from "./RichTextarea.vue?vue&type=script&lang=js"
import style0 from "./RichTextarea.vue?vue&type=style&index=0&id=23a95104&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports